/**
 * Maps sport to MendOnBend Recovery & Resilience URLs.
 * Use clean URLs (no .html) - .html URLs redirect to recovery-resilience hub.
 */
const MENDONBEND_BASE = 'https://www.mendonbend.com';
const RECOVERY_HUB_URL = `${MENDONBEND_BASE}/recovery-resilience`;

// Sport id/name → MendOnBend athletic recovery page (clean URLs)
const SPORT_RECOVERY_URLS: Record<string, string> = {
  pickleball: `${MENDONBEND_BASE}/athletic-recovery-pickleball`,
  tennis: `${MENDONBEND_BASE}/athletic-recovery-tennis`,
  badminton: `${MENDONBEND_BASE}/athletic-recovery-badminton`,
  squash: `${MENDONBEND_BASE}/athletic-recovery-squash`,
  golf: `${MENDONBEND_BASE}/athletic-recovery-golf`,
  padel: `${MENDONBEND_BASE}/athletic-recovery-padel`,
  racquetball: `${MENDONBEND_BASE}/athletic-recovery-racquetball`,
  hiking: `${MENDONBEND_BASE}/athletic-recovery-hiking`,
  running: `${MENDONBEND_BASE}/athletic-recovery-running`,
  cycling: `${MENDONBEND_BASE}/athletic-recovery-cycling`,
  swimming: `${MENDONBEND_BASE}/athletic-recovery-swimming`,
  strength: `${MENDONBEND_BASE}/athletic-recovery-strength`,
};

// Keywords that indicate injury/recovery content
const INJURY_KEYWORDS = [
  'elbow', 'shoulder', 'knee', 'wrist', 'back', 'hip',
  'pain', 'injury', 'strain', 'tendinitis', 'tennis elbow',
  'golfer\'s elbow', 'rotator cuff', 'achilles', 'ankle',
  'calf', 'abdominal', 'tendinopathy', 'impingement', 'sprain',
  'fracture', 'patellar', 'gastrocnemius', 'tennis leg',
  'pickleball elbow', 'padel elbow', 'plantar fasciitis', 'hiker\'s knee'
];

export function isRecoveryRelevant(issue: string, shotType?: string): boolean {
  const check = (s: string) => INJURY_KEYWORDS.some(kw => s.toLowerCase().includes(kw));
  return check(issue) || (!!shotType && check(shotType));
}

function appendRef(url: string): string {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}ref=mysportscoach`;
}

export function getRecoveryUrl(sport: string, _issue?: string, _shotType?: string): string {
  const sportSlug = sport.toLowerCase().replace(/\s+/g, '-');
  const url = SPORT_RECOVERY_URLS[sportSlug] || RECOVERY_HUB_URL;
  return appendRef(url);
}
